import React, { useState, useEffect } from 'react';
import { Box } from '@mui/material';
import FilterChip from './FilterChip';
import { organizationApi } from '../../../services/api';
import { useAlert } from '../../../contexts/AlertContext';
import { COLORS } from '../../../constants/radar';

const Grades = ({ 
  selectedGrades = [], 
  onGradeToggle,
  sx = {} 
}) => {
  const [grades, setGrades] = useState([]);
  const [loading, setLoading] = useState(true);
  const { showAlert } = useAlert();

  useEffect(() => {
    const fetchGrades = async () => {
      try {
        setLoading(true);
        const gradesData = await organizationApi.getAllGrades();
        setGrades(gradesData || []);
      } catch (error) {
        showAlert('Failed to load grades', 'error', error);
      } finally {
        setLoading(false);
      }
    };

    fetchGrades();
  }, [showAlert]);

  if (loading) {
    return (
      <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', ...sx }}>
        <FilterChip
          label="Loading grades..."
          isSelected={false}
          onClick={() => {}}
          backgroundColor="#f3f4f6"
          textColor="#6b7280"
          borderColor="#e5e7eb"
          disabled
        />
      </Box>
    );
  }

  return (
    <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', ...sx }}>
      {grades.map((grade) => {
        const isSelected = selectedGrades.includes(grade.id);
        
        return (
          <FilterChip
            key={grade.id}
            label={grade.label}
            isSelected={isSelected}
            onClick={() => onGradeToggle(grade.id)}
            backgroundColor={isSelected ? COLORS.PRIMARY : 'transparent'}
            textColor={isSelected ? 'white' : COLORS.PRIMARY}
            borderColor={COLORS.PRIMARY}
            showDot={true}
          />
        );
      })}
    </Box>
  );
};

export default Grades; 